import React, { memo } from "react";
import { ThemeProvider } from "emotion-theming";
import { getAppTheme } from "assets/scss/common/theme";
import GlobalStyle from "assets/scss/common/globalStyle";
import createLightTheme from "@nykaa/ui-components/themes/lightTheme/createLightTheme";
import RouteWithSubRoutes from "./subRoute";
import {
  FASHION_BASE_THEME,
  FOOTLOCKER_BASE_THEME,
  MEN_BASE_THEME,
  NYKAA_BASE_THEME,
} from "assets/scss/common/theme/baseTheme";
import { platformNames } from "shared/constants";
import { getActualDeviceType } from "helpers/utils/getActualDeviceType";
import { mobileRoutes } from "routeConfig/mobile";
import { desktopRoutes } from "routeConfig/desktop";


const appTheme = getAppTheme();
let themeObj = {};
switch (__PLATFORM__) {
  case platformNames.FASHION:
    themeObj = FASHION_BASE_THEME;
    break;
  case platformNames.FOOTLOCKER:
    themeObj = FOOTLOCKER_BASE_THEME;
    break;
  case platformNames.MEN:
    themeObj = MEN_BASE_THEME;
    break;
  default:
    themeObj = NYKAA_BASE_THEME;
}

const newTheme = createLightTheme(themeObj);

const theme = {
  ...appTheme,
  ...newTheme,
};

const App = ({ deviceType }: { deviceType?: string }) => {
  /**This or condition is added to get device type on server */
  const device = getActualDeviceType() || deviceType;
  const getRoutes = (typeOfdevice: string) => {
    let routes: any = mobileRoutes;

    if (typeOfdevice === "desktop") {
       routes = desktopRoutes;
    }

    return routes;
  };

  let routes = getRoutes(device);

  return (

    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <RouteWithSubRoutes routes={routes} />
    </ThemeProvider>

  );
};

export default memo(App);
